import { c as _c } from "react/compiler-runtime";
import type { Entry } from "contentful";
import { buildBlogPostingJsonLd } from "@/lib/blog-jsonld";
import type { TypeBlogArticleSkeleton } from "@/types/contentful/generated";
import { JsonLd } from "../JsonLd";
import { BlogCard } from "./BlogCard";
export const BlogPostGrid = t0 => {
  const $ = _c(18);
  const {
    postPages,
    setSentinelRef
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== postPages) {
    const allPosts = postPages.flatMap(_temp);
    t1 = "https://schema.org";
    t2 = "CollectionPage";
    t3 = "Blog";
    t4 = allPosts.map(_temp2);
    $[0] = postPages;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    const blogCollectionJsonLd = {
      "@context": t1,
      "@type": t2,
      name: t3,
      mainEntity: t4
    };
    t5 = <JsonLd data={blogCollectionJsonLd} />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== postPages || $[11] !== setSentinelRef) {
    let t7;
    if ($[13] !== setSentinelRef) {
      t7 = t8 => {
        const {
          page: page_0,
          posts: pagePosts
        } = t8;
        return <div key={`page-${page_0}`}><div ref={setSentinelRef(page_0)} data-page={page_0} className="h-0" aria-hidden="true" /><div className="grid grid-cols-1 lg:grid-cols-3 gap-6 pb-6">{pagePosts.map(_temp3)}</div></div>;
      };
      $[13] = setSentinelRef;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    t6 = postPages.map(t7);
    $[10] = postPages;
    $[11] = setSentinelRef;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
function _temp(page) {
  return page.posts;
}
function _temp2(post) {
  return buildBlogPostingJsonLd(post);
}
function _temp3(post_0) {
  return <div key={post_0.sys.id} className="animate-in fade-in slide-in-from-bottom-4 duration-500 fill-mode-both"><BlogCard post={post_0} /></div>;
}